import React from "react";
import { Hero } from "../components/sections/Hero";
import { DigitalEcosystem } from "../components/sections/DigitalEcosystem";
import { ServicesPreview } from "../components/sections/ServicesPreview";
import { WhyChooseUs } from "../components/sections/WhyChooseUs";
import { Stats } from "../components/sections/Stats";
import { ProcessTimeline } from "../components/sections/ProcessTimeline";
import { Founder } from "../components/sections/Founder";
import { FeaturedProjects } from "../components/sections/FeaturedProjects";
import { Testimonials } from "../components/sections/Testimonials";
import { FAQ } from "../components/sections/FAQ";
import { CTASection } from "../components/sections/CTASection";
import { useSeo, organizationSchema, faqSchema } from "../lib/useSeo";
import { useI18n } from "../lib/i18n";

export default function HomePage() {
  const { locale, t } = useI18n();
  useSeo({
    title:
      locale === "de"
        ? "Joshi FusionTech Media — KI Automatisierung & Digitalagentur Berlin"
        : "Joshi FusionTech Media — AI Automation & Digital Agency Berlin",
    description:
      locale === "de"
        ? "Joshi FusionTech Media unterstützt Unternehmen mit Webentwicklung, AI-Automatisierung, Digital Marketing und Branding für nachhaltiges Wachstum — Digitalagentur aus Berlin."
        : "Joshi FusionTech Media helps businesses grow with web development, AI automation, digital marketing and branding — Berlin-based digital agency.",
    canonical: "https://www.joshifusiontech.de/",
    locale,
    jsonLd: [organizationSchema(), faqSchema(t.faq.items)],
  });
  return (
    <main data-testid="home-page">
      <Hero />
      <DigitalEcosystem />
      <ServicesPreview />
      <WhyChooseUs />
      <Stats />
      <ProcessTimeline />
      <Founder />
      <FeaturedProjects />
      <Testimonials />
      <FAQ />
      <CTASection />
    </main>
  );
}
